import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import { Alert as MuiAlert, Color } from "@material-ui/lab";
import styled from "styled-components/macro";
import { spacing } from "@material-ui/system";

const Alert = styled(MuiAlert)(spacing);

export type Notify = {
    isOpen: boolean,
    message: string,
    type: Color
}
export type NotificationProps = {
    notify: Notify,
    setNotify: React.Dispatch<Notify>
    className?: string
}
export const Notification = (p: NotificationProps) => {
    const { notify, setNotify } = p;

    return (
        < React.Fragment>
            {notify.isOpen === true ?
                <Alert
                    className={p.className ?? ""}
                    icon={<CheckIcon fontSize="inherit" />}
                    mt={4}
                    severity={notify.type}
                    onClose={() => {
                        setNotify({
                            ...notify,
                            isOpen: false
                        })
                    }}
                >
                    {notify.message}
                </Alert> : null}
        </React.Fragment>
    )
}
